export const CAROUSEL_WIDTH = 1300
export const CAROUSEL_SLIDE_WIDTH = 614

const slidesPerView =
  1 + (CAROUSEL_WIDTH - CAROUSEL_SLIDE_WIDTH) / CAROUSEL_SLIDE_WIDTH

export const SWIPER_CONFIG = {
  slidesPerView: slidesPerView,
  spaceBetween: 0,
  speed: 500,
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 1,
  breakpoints: {
    768: {
      slidesPerView: 1
    }
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  lazy: {
    loadPrevNext: true
  },
  pagination: {
    el: '.tp-Carousel_Pagination',
    clickable: true
  },
  navigation: {
    prevEl: '.tp-Carousel_Button-prev',
    nextEl: '.tp-Carousel_Button-next'
  }
}
